import extract, {sanitize, replace} from '../core/extract'
import i18n from './i18n'

function extractError(target, error) {
    const errorType = sanitize(error && error.type)

    if (target) {
        const errorData = error && error.data
        const targetError = target[errorType]

        switch(errorType) {
        	case 'stepCoherencyError':
        		return targetError && errorData.errors.map((error) => {
                    return targetError[sanitize(error.error)] || null
                })
            default:
                return targetError || null
        }
    }
    return null
}

function replaceError(value, error) {
    if (value) {
        const errorType = sanitize(error && error.type)
        const errorData = error && error.data

        switch(errorType) {
            case 'stepCoherencyError':
                return errorData.errors.map((error, index) => {
                    return replace(value[index], {
                        stepInError: extract(i18n.expectedEventEnum, error.stepInError.expectedEvent),
                        stepsBefore: error.stepsBefore && error.stepsBefore.map((sb) => extract(i18n.expectedEventEnum, sb.expectedEvent)).join(', ')
                    })
                }).join('. ')
            case 'companyDoesNotHaveRequieredBillingTypeLevel':
                return replace(value, {
                    expectedLevels: errorData.expectedLevels.map((el) => extract(i18n.billingTypeEnum, el)).join(', ')
                })
            default:
                return replace(value, errorData)
        }
    }
    return value
}

export default function(error) {
	return replaceError(extractError(i18n.errorTypeEnum, error), error)
}


// WEBPACK FOOTER //
// ./lib/workflow/errors.js